/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/StarClub/SCChallengePack',[
    'lodash',
    'absolute/stringmanager',
    'Managers/ChallengeManager',
    'Managers/ChallengeFactory'
], function (_, _s, ChallengeManager, ChallengeFactory) {
    "use strict";

    var SCChallengePack = function (packConfig, icon, theme) {
        this.initSCChallengePack(packConfig, icon, theme);
    };

    SCChallengePack.GuidCache = {};

    SCChallengePack.prototype.initSCChallengePack = function (packConfig, icon, theme) {
        this.config = packConfig;
        this.icon = icon;
        this.theme = theme;
        this.Challenges = [];

        ChallengeManager.StoreChallengePack(packConfig);
        // create the challenges configs

        _.forEach(packConfig.PMChallenges, function (challengeConfig) {
            var challengeData = challengeConfig.ChallengeData,
                key = ChallengeManager.StoreChallenge(challengeData);

            if(SCChallengePack.GuidCache[key]) {
                challengeData.Key += "_ALLOW_DUPE";
            }

            var challenge = this.buildChallenge(challengeData);

            if (challenge) {
                this.Challenges.push(challenge);
            }

            SCChallengePack.GuidCache[key] = true;

        }, this);

        ChallengeManager.Sync();
    };

    Object.defineProperty(SCChallengePack.prototype, "Name", {
        get: function () {
            var difficultyLabels = ['Easy', 'Medium', 'Hard', 'Expert'];
            this.config.Name += difficultyLabels.some(function(label) {
                return label === this.config.Name;
            }.bind(this)) ? 'Text' : '';
            if (this.config.DigitNamePack) {
                return _s(this.config.Name) + " " + this.config.DigitNamePack;
            }
            else {
                return this.config.Name;
            }
        }
    });

    Object.defineProperty(SCChallengePack.prototype, "NumStars", {
        get: function () {
            var stars = 0;
            for (var c = 0; c < this.Challenges.length; c++) {
                stars += this.Challenges[c].Difficulty;
            }
            return stars;
        }
    });

    Object.defineProperty(SCChallengePack.prototype, "NumStarsEarned", {
        get: function () {

            var starsEarned = 0;

            _.forEach(this.config.PMChallenges, function (challengeConfig) {
                var ci = ChallengeManager.GetChallengeConfig(challengeConfig.ChallengeData.Key);

                if (ci && ci.Completed) {
                    starsEarned += ci.Difficulty;
                }
            });

            return starsEarned;
        }
    });


    Object.defineProperty(SCChallengePack.prototype, "Unlocked", {
        get: function () {
            return this.config.PriceOfUnlocking == 0 || ChallengeManager.IsChallengePackUnlocked(this.config.ID);
        },
        set: function (value) {
            ChallengeManager.SetChallengePackUnlocked(this.config.ID, value);
        }
    });

    Object.defineProperty(SCChallengePack.prototype, "PriceOfUnlocking", {
        get: function () {

            return this.config.PriceOfUnlocking;
        }
    });

    Object.defineProperty(SCChallengePack.prototype, "SentientId", {
        get: function () {

            return this.config.SentientId;
        }
    });

    Object.defineProperty(SCChallengePack.prototype, "ChallengesCompleted", {
        get: function () {
            var stats = this.getPackStats();
            return stats.challengesCompleted;
        }
    });


    SCChallengePack.prototype.buildChallenge = function (challengeData) {

        var ci = ChallengeManager.GetChallengeConfig(challengeData.Key);
        var challenge = ChallengeFactory.BuildChallengeObject(ci);

        if (challenge) {
            challenge.Theme = this.theme;
        }

        return challenge;
    };


    SCChallengePack.prototype.getPackStats = function () {
        var stats = {
                totalStarsEarned: 0,
                challengesCompleted: 0,
                totalChallenges: 0
            };

        _.forEach(this.config.PMChallenges, function (challengeConfig) {
            var ci = ChallengeManager.GetChallengeConfig(challengeConfig.ChallengeData.Key);
            stats.totalChallenges++;
            if (ci && ci.Completed) {
                stats.challengesCompleted++;
                stats.totalStarsEarned += ci.Difficulty;
            }
        });

        return stats;

    };


    return SCChallengePack;


});

